export default function Footer() {
  return (
    <footer id="footer" className="bg-background-800 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <span className="text-lg font-bold text-background-50 font-heading block mb-4">
              国产91视频
            </span>
            <p className="text-sm text-background-400 leading-relaxed">
              国产91视频致力于为用户提供久久视频、芒果视频、97视频、丝瓜视频、蓝莓视频等在线视频网站资源导航，通过视频播放器在线看视频，打造便捷高效的综合视频资源平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">快速导航</h4>
            <div className="space-y-2.5">
              <a href="#index" className="block text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">主题索引</a>
              <a href="#about" className="block text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">关于平台</a>
              <a href="#media" className="block text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">视频资源</a>
              <a href="#ranking" className="block text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">热门榜单</a>
              <a href="#faq" className="block text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">资源站点</h4>
            <div className="space-y-2.5">
              <span className="block text-sm text-background-400 whitespace-nowrap">久久视频</span>
              <span className="block text-sm text-background-400 whitespace-nowrap">芒果视频</span>
              <span className="block text-sm text-background-400 whitespace-nowrap">97视频</span>
              <span className="block text-sm text-background-400 whitespace-nowrap">丝瓜视频</span>
              <span className="block text-sm text-background-400 whitespace-nowrap">蓝莓视频</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">
              合作伙伴信息持续更新中，欢迎优质在线视频网站与我们联系合作。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              国产91视频 © 2026 版权所有 | 久久视频 · 芒果视频 · 97视频 · 丝瓜视频在线视频网站资源导航
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-background-500 whitespace-nowrap">视频播放器在线看视频</span>
              <span className="text-xs text-background-500 whitespace-nowrap">在线视频网站导航</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}